//import * as auth from '@/services/auth_service';
import { http } from '@/services/http_service';
export default{
    sendMessage(context, data)
    {
        http()
        .post("/chat/sendMessage", data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log(response.data)
        },function(error){
            console.log(error.response.data)
        });
    },
    createRoom(context, data)
    {
        //앞단에서 받아서 판별이 필요하기 때문에 return
        return http()
        .post("/chat/chatroom/store", data)
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log(response.data);
            context.dispatch('fechChatroomList')
            return response.data;
        });
    },
    getRoomInfo(context, data)
    {
        return http()
        .get("/chat/chatroom/info", {params:{roomId:data.roomId}})
        .then((response) =>{
            // console.log("getRoomInfo",data);
            // console.log("getRoomInfo",response);
            context.commit('setRoomInfo', response.data)
            return response.data
        });
    },
    fechChatroomList(context)
    {
        return http()
        .get("/chat/chatroom/fetchLists")
        .then((response) => {
            //context.commit('setMessages', response.data)
            console.log('챗룸 리스트정보',response.data)
            context.commit('setRoomList', response.data)
            return response.data;
        },function(error){
            console.log(error.response.data)
        });
    },
    addManager(context, data)
    {
        //채팅매니져 등록 및 삭제, 없으면 등록 있으면 삭제
        return http()
        .post("/chat/addManager", data)
        .then((response) => {

            console.log(response.data); 
            context.commit('updateRoomList', response.data.roomInfo)          
            return response.data;
        });
    },
    forcedOut(context, data)
    {
        //강퇴 처리 DB기록 하고 채팅방 재 진입을 막는다.
        return http()
        .post("/chat/forcedOut", data)
        .then((response) => {

            console.log(response.data); 
            context.commit('updateRoomList', response.data.roomInfo)          
            return response.data;
        });
    },
    // fetchMessages(context, payload ){
    //     context.getters.http
    //     .get("/chat/fetchmessages")
    //     .then((response) => {
    //         context.commit('fetchMessages', response.data)
    //     },function(error){
    //         console.log(error.response.data)
    //     });
    // }
}
